module.exports = __webpack_public_path__ + "img/13.thunderstorm-light.9da69ca1.svg";